import type { ReactNode } from 'react';
import { useRota } from '../rota';

/**
 * A barra de baixo, com os quatro lugares do mockup. O ícone da Carteira é a
 * órbita da marca; os outros três seguem o traço fino de 1.5 do design.
 */

type Aba = { rota: string; nome: string; icone: (ativo: boolean) => ReactNode };

const tinta = (ativo: boolean) => (ativo ? 'var(--ink)' : 'rgba(20,18,15,.4)');

const ABAS: Aba[] = [
  {
    rota: '/',
    nome: 'Carteira',
    icone: (a) => (
      <svg width="24" height="18" viewBox="0 0 24 18">
        <g transform="rotate(-25 12 9)">
          <ellipse cx="12" cy="9" rx="9" ry="5.4" fill="none" stroke={tinta(a)} strokeWidth="1.7" />
          <circle cx="21" cy="9" r="2.2" fill="var(--accent)" />
        </g>
      </svg>
    ),
  },
  {
    rota: '/lojinha',
    nome: 'Lojinha',
    icone: (a) => (
      <svg width="24" height="18" viewBox="0 0 24 18">
        <path
          d="M6 6.5h12l-1.2 9.5H7.2Z"
          fill="none"
          stroke={tinta(a)}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path d="M9 6.5V5a3 3 0 0 1 6 0v1.5" fill="none" stroke={tinta(a)} strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    rota: '/cupons',
    nome: 'Cupons',
    icone: (a) => (
      <svg width="24" height="18" viewBox="0 0 24 18">
        <rect x="3.5" y="3.5" width="17" height="11" rx="2.5" fill="none" stroke={tinta(a)} strokeWidth="1.5" />
        <path d="M12 4.5v9" stroke={tinta(a)} strokeWidth="1.5" strokeDasharray="2 2.5" />
      </svg>
    ),
  },
  {
    rota: '/perfil',
    nome: 'Perfil',
    icone: (a) => (
      <svg width="24" height="18" viewBox="0 0 24 18">
        <circle cx="12" cy="6" r="3.2" fill="none" stroke={tinta(a)} strokeWidth="1.5" />
        <path d="M5.5 16a6.5 5.5 0 0 1 13 0" fill="none" stroke={tinta(a)} strokeWidth="1.5" />
      </svg>
    ),
  },
];

export function TabBar() {
  const { caminho, ir } = useRota();
  return (
    <nav className="abas">
      {ABAS.map((aba) => {
        const ativa = aba.rota === '/' ? caminho === '/' : caminho.startsWith(aba.rota);
        return (
          <button key={aba.rota} className="aba" onClick={() => ir(aba.rota)}>
            {aba.icone(ativa)}
            <span style={{ color: tinta(ativa), fontWeight: ativa ? 500 : 400 }}>{aba.nome}</span>
          </button>
        );
      })}
    </nav>
  );
}
